<template lang="pug">
  div.nav
    nav
      div.toolbar-navigation
        e-form-tabs(
        v-model="tabView"
        :tabs="[{tab1: 'Общие сведения'},{tab2: 'Файлы'},{tab4: 'Смена пароля'}]"
        )
        div.toolbar-settings
      div.toolbar-navigation__filter

</template>

<script>
  export default {
    name: 'components-nav',
    data () {
      return {
        tabView: 'tab1'
      }
    }
  }
</script>
